import types, { ActionCreators } from './types';

const clearOfferComponentStateAction: ActionCreators['ClearOfferComponentState'] = () => ({
  type: types.CLEAR_OFFER_COMPONENT_STATE,
});

const clearGetStartedStateAction: ActionCreators['ClearGetStartedState'] = () => ({
  type: types.CLEAR_GET_STARTED_STATE,
});

const requestOffer: ActionCreators['RequestOffer'] = (offerId) => ({
  type: types.REQUEST_OFFER,
  offerId,
});

const requestOfferERR: ActionCreators['RequestOfferERR'] = (errorMessages, error) => ({
  type: types.REQUEST_OFFER_ERR,
  errorMessages,
  error,
});

const requestOfferOK: ActionCreators['RequestOfferOK'] = (offerAttributes) => ({
  type: types.REQUEST_OFFER_OK,
  ...offerAttributes,
});

const actions = {
  clearOfferComponentStateAction,
  clearGetStartedStateAction,
  requestOffer,
  requestOfferERR,
  requestOfferOK,
};

export default actions;
